module.exports = __webpack_public_path__ + "img/erweima.276d456f.png";